// extracted by mini-css-extract-plugin
export default {"border-container":"1px solid rgb(221, 224, 230)","cardHeader":"styles_cardHeader__z5dTV"};